import { Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import DeviceStatusBadge from "../../../Components/DeviceStatusBadge";
import SortableTable from "../../../Components/SortableTable";

import {
  ECABIN,
  checkAdmin,
  formatTimeWithTZOffset,
  getLatestLifeCycleState,
} from "../../../Utils/Common";

export default function DeviceHistory({ data, width }) {
  const history = useHistory();
  const [searchList, setSearchList] = useState();
  const { t } = useTranslation();

  const createElements = (contact) => {
    var ar = [];
    contact.LifeCycleStates.forEach((lcs, i) => {
      if (!ar || !ar.find((o) => lcs.Device.serialNumber === o.serialNumber)) {
        var obj = {
          createdAt: formatTimeWithTZOffset(lcs.createdAt, ECABIN),
          serialNumber: lcs.Device.serialNumber,
          user:
            lcs.Device.LifeCycleStates.find((o) => o.id === lcs.id).User
              ?.fullName ?? "",
          withClient:
            getLatestLifeCycleState(lcs.Device.LifeCycleStates).updatedAt ===
            lcs.updatedAt
              ? t("yes")
              : t("returned"),
          DeviceId: lcs.Device.id,
        };
        ar.push(obj);
      }
    });
    setSearchList(ar);
  };

  useEffect(() => {
    if (data) {
      createElements(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return width === "xs" && searchList && searchList.length ? (
    searchList
      .sort((a, b) =>
        a.createdAt > b.createdAt ? -1 : b.createdAt > a.createdAt ? 1 : 0
      )
      .map((val, i) => (
        <DeviceStatusBadge data={val} onClick={() => {}} key={i} />
      ))
  ) : searchList && searchList.length ? (
    <SortableTable
      headCells={[
        {
          id: "serialNumber",
          numeric: false,
          disablePadding: false,
          label: t("serialNumber"),
        },
        {
          id: "createdAt",
          numeric: false,
          disablePadding: false,
          label: t("date"),
        },
        {
          id: "user",
          numeric: false,
          disablePadding: false,
          label: t("representativeName"),
        },
        {
          id: "withClient",
          numeric: false,
          disablePadding: false,
          label: t("dispatchedDevices.withClient"),
        },
      ]}
      disablePagination={true}
      defaultSortRow={"serialNumber"}
      handleRowClick={(e, v) => {
        history.push(
          (checkAdmin() ? "/cpanel" : "") + "/devices/" + e.DeviceId
        );
      }}
      // handleScrollClick: showDeviceNewTab,
      tableData={searchList}
      rowsPerPage={200}
    />
  ) : searchList ? (
    <Typography>{t("dispatchedDevices.noDispatchedDevices")}</Typography>
  ) : null;
}
